module.exports = __webpack_public_path__ + "img/calavazas.af78af32.svg";